// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__B3RRQ","appointment":"styles_appointment__0Tbe2"};